import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import drivingMarketParamsReducer from "../drivingMarketParams";
import mostActiveByValueReducer from "./mostActiveByValue";
export default combineReducers({
    reducersData: mostActiveByValueReducer,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
